// Production-only registration for public/sw.js (offline caching).

function unregisterLegacyFontServiceWorkers() {
  return navigator.serviceWorker.getRegistrations().then((regs) =>
    Promise.all(
      regs.map((reg) => {
        const scriptUrl =
          (reg.active && reg.active.scriptURL) ||
          (reg.waiting && reg.waiting.scriptURL) ||
          (reg.installing && reg.installing.scriptURL) ||
          '';
        if (scriptUrl.includes('font-cache-sw.js')) {
          return reg.unregister();
        }
        return Promise.resolve();
      })
    )
  );
}

function notifyUpdate(config, registration) {
  if (typeof config?.onUpdate === 'function') {
    config.onUpdate(registration);
  }
}

/**
 * @param {{ onUpdate?: (registration: ServiceWorkerRegistration) => void }} [config]
 */
export function register(config = {}) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const publicUrl = process.env.PUBLIC_URL || '';
    const swUrl = `${publicUrl}/sw.js`;

    unregisterLegacyFontServiceWorkers()
      .catch(() => {})
      .finally(() => {
        navigator.serviceWorker
          .register(swUrl)
          .then((registration) => {
            if (registration.waiting && navigator.serviceWorker.controller) {
              notifyUpdate(config, registration);
            }

            registration.addEventListener('updatefound', () => {
              const installing = registration.installing;
              if (!installing) return;
              installing.addEventListener('statechange', () => {
                if (
                  installing.state === 'installed' &&
                  navigator.serviceWorker.controller
                ) {
                  // New SW ready (skipWaiting in sw.js). Prompt user to reload.
                  notifyUpdate(config, registration);
                }
              });
            });
          })
          .catch((err) => {
            console.warn('Service worker registration failed:', err);
          });
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch(() => {});
  }
}
